module.exports = __webpack_public_path__ + "static/media/main-img.c032d8cc.webp";